"use client";

export default function Error({
  error
}: {
  error: Error & { digest?: string };
}) {
  console.error("Error", error?.message || error);
}
